import localDB from "./localDB";
let GLOBAL = require('./globals');

const SalePaymentData = {
    async delete(id, res) {
        await fetch(`${GLOBAL.BASE_URL}api/sale-payment/${id}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    },
    async update(data, res) {
        await fetch(`${GLOBAL.BASE_URL}api/sale-payment/${data.id}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    },
};

export default SalePaymentData;


// WEBPACK FOOTER //
// ./src/data/SalePaymentData.js